import React, { Component } from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import Select from "react-select"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import {
    AccountTransactionTypeInvoice,
    AccountTransactionTypeCreditMemo
} from "../../../../state/contact/AccountTransactionsType"

const messages = defineMessages({
    dueDate: {
        id: "templates.sections.form.edit.content.customer_account_statement.due_date",
        defaultMessage: "Due date"
    },
    fullyPaidAt: {
        id: "templates.sections.form.edit.content.customer_account_statement.fully_paid_date",
        defaultMessage: "Fully paid date"
    },
    createdAt: {
        id: "templates.sections.form.edit.content.customer_account_statement.created_date",
        defaultMessage: "Created date"
    },
    capturedAt: {
        id: "templates.sections.form.edit.content.customer_account_statement.captured_date",
        defaultMessage: "Credit Memo Captured date"
    },
    sentAt: {
        id: "templates.sections.form.edit.content.customer_account_statement.sent_date",
        defaultMessage: "Sent date"
    },
    poNumber: {
        id: "templates.sections.form.edit.content.customer_account_statement.po_number",
        defaultMessage: "PO number"
    },
    uniqueExternalId: {
        id: "templates.sections.form.edit.content.customer_account_statement.external_id",
        defaultMessage: "Lightspeed ID"
    },
    lightspeedWorkorderId: {
        id: "templates.sections.form.edit.content.customer_account_statement.workorder_id",
        defaultMessage: "Workorder ID"
    }
})

class CustomerAccountStatementContentInput extends Component {
    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        let customFields = content.customFields || []
        customFields = customFields.map(customField => JSON.parse(customField))

        this.state = {
            className: this.props.className || "",
            onChange: this.props.onChange || function() {},
            hideInvoices: content.hideInvoices || false,
            hideCreditMemos: content.hideCreditMemos || false,
            hideCreditMemosCreatedAt: content.hideCreditMemosCreatedAt || false,
            customFields: customFields || [],
            customFieldsOptions: [
                {
                    value: "dueDate",
                    label: this.props.intl.formatMessage(messages["dueDate"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "fullyPaidAt",
                    label: this.props.intl.formatMessage(messages["fullyPaidAt"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "createdAt",
                    label: this.props.intl.formatMessage(messages["createdAt"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "sentAt",
                    label: this.props.intl.formatMessage(messages["sentAt"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "poNumber",
                    label: this.props.intl.formatMessage(messages["poNumber"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "uniqueExternalId",
                    label: this.props.intl.formatMessage(messages["uniqueExternalId"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "lightspeedWorkorderId",
                    label: this.props.intl.formatMessage(messages["lightspeedWorkorderId"]),
                    type: AccountTransactionTypeInvoice
                },
                {
                    value: "capturedDate",
                    label: this.props.intl.formatMessage(messages["capturedAt"]),
                    type: AccountTransactionTypeCreditMemo
                }
            ]
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleCustomFields = this.handleCustomFields.bind(this)
        this.handleCustomFieldLabel = this.handleCustomFieldLabel.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            hideInvoices: this.state.hideInvoices,
            hideCreditMemosCreatedAt: this.state.hideCreditMemosCreatedAt,
            hideCreditMemos: this.state.hideCreditMemos,
            customFields: this.state.customFields.map(field => {
                return {
                    customFieldId: field.customFieldId,
                    customFieldLabel: field.customFieldLabel,
                    customFieldType: field.customFieldType
                }
            })
        })
    }

    componentDidMount() {
        this.triggerChanged()

        AppContext.getApiClient()
            .get("/custom-field-definitions")
            .then(r => {
                let customFieldsOptions = []
                let customFields = [...this.state.customFields]
                for (let cf of r.data) {
                    if (cf.attributes.fieldType !== "image") {
                        customFieldsOptions.push({
                            value: cf.id,
                            label: cf.attributes.name
                        })

                        let customField = customFields.find(customField => customField.customFieldId === cf.id)
                        if (customField) {
                            customField.originalLabel = cf.attributes.name
                        }
                    }
                }
                this.setState({
                    customFieldsOptions: this.state.customFieldsOptions.concat(customFieldsOptions),
                    customFields
                })
            })
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            hideInvoices: content.hideInvoices || false,
            hideCreditMemos: content.hideCreditMemos || false
        })
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        this.setState(
            {
                [name]: value
            },
            this.triggerChanged
        )
    }

    handleCustomFields(customFields) {
        if (customFields.length > 3) {
            customFields = customFields.slice(0, 3)
        }

        this.setState(
            {
                customFields: customFields.map(option => {
                    return {
                        originalLabel: option.label,
                        customFieldLabel: option.label,
                        customFieldId: option.value,
                        customFieldType: option.type
                    }
                })
            },
            this.triggerChanged
        )
    }

    handleCustomFieldLabel(index, event) {
        let customFields = [...this.state.customFields]
        customFields[index].customFieldLabel = event.target.value

        this.setState(
            {
                customFields
            },
            this.triggerChanged
        )
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideInvoices"
                                name="hideInvoices"
                                value={this.state.hideInvoices}
                                checked={this.state.hideInvoices}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideInvoices">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_invoices_label"
                                    defaultMessage="Hide invoices list"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_invoices_description"
                                    defaultMessage="This will hide the summary of due invoices with the total balance."
                                />
                            </small>
                        </div>
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideCreditMemos"
                                name="hideCreditMemos"
                                value={this.state.hideCreditMemos}
                                checked={this.state.hideCreditMemos}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideCreditMemos">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_credit_memos_label"
                                    defaultMessage="Hide credit memos list"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_credit_memos_description"
                                    defaultMessage="This will hide the summary of credit memos available with the total balance."
                                />
                            </small>
                        </div>
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideCreditMemosCreatedAt"
                                name="hideCreditMemosCreatedAt"
                                value={this.state.hideCreditMemosCreatedAt}
                                checked={this.state.hideCreditMemosCreatedAt}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideCreditMemosCreatedAt">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_credit_memos_created_at_label"
                                    defaultMessage="Hide credit memos created at"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.customer_account_statement.hide_credit_memos_created_at_description"
                                    defaultMessage="This will hide the created at column of the credit memos list."
                                />
                            </small>
                        </div>
                        <label className="mt-4 mb-0" htmlFor="hideCreditMemos">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.customer_account_statement.custom_columns_label"
                                defaultMessage="Custom columns"
                            />
                        </label>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.customer_account_statement.custom_columns_description"
                                defaultMessage="You may add up to 3 custom columns. They will appear between the identifier and the amount columns in the selected order."
                            />
                        </small>

                        <Select
                            searchable={false}
                            multi
                            value={this.state.customFields.map(customField => customField.customFieldId)}
                            onChange={this.handleCustomFields}
                            options={this.state.customFieldsOptions}
                        />

                        {this.state.customFields.length > 0 && (
                            <div>
                                <small className="form-text text-muted mt-3">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.customer_account_statement.custom_columns_names"
                                        defaultMessage="You may change the displayed name for the selected columns in the header."
                                    />
                                </small>
                                <div className="row">
                                    {this.state.customFields.map((customField, index) => {
                                        return (
                                            <div className="col-4">
                                                <label className="mb-1">
                                                    {messages[customField.customFieldId]
                                                        ? this.props.intl.formatMessage(messages[customField.customFieldId])
                                                        : customField.originalLabel}
                                                </label>
                                                <input
                                                    name={customField.customFieldLabel + index}
                                                    value={customField.customFieldLabel}
                                                    onChange={event => this.handleCustomFieldLabel(index, event)}
                                                    id={customField.customFieldId}
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(CustomerAccountStatementContentInput)



// WEBPACK FOOTER //
// ./src/template/sections/content/customer-account-statement/input.component.jsx